/**
 * @module Misc Types
 */
export {};
